import { faAllergies } from '@fortawesome/free-solid-svg-icons';
export default {
    data() {
        return {
            categories: [
                {
                    name: 'TREE',
                    displayName: 'Trees',
                    image: require('../../assets/images/allergenCategory/tree.jpg')
                },
                {
                    name: 'WEED',
                    displayName: 'Weeds',
                    image: require('../../assets/images/allergenCategory/weed.jpg')
                },
                {
                    name: 'GRASS',
                    displayName: 'Grass',
                    image: require('../../assets/images/allergenCategory/grass.jpg')
                },
                {
                    name: 'MOLD',
                    displayName: 'Mold',
                    image: require('../../assets/images/allergenCategory/mold.jpg')
                }
            ]
        };
    },
    methods: {
        getTop: function (allergenCollectionSet, categoryName, number) {
            if (!number)
                number = 3;

            let nonNulls = allergenCollectionSet.allergenCollections.filter(x => x.allergen.category == categoryName);
            if (nonNulls.length == 0)
                return null;

            let retVal = nonNulls.filter(x => x.value > 0).sort((a, b) => parseInt(a.value) == parseInt(b.value) ? 0 : (parseInt(a.value) > parseInt(b.value) ? -1 : 1));
            if (retVal.length <= number)
                return retVal;

            // If there are more than 3, return the top 3, including any ties for third
            return retVal.filter(x => x.value >= retVal[number - 1].value);
        },
        getScale: function (station, category) {
            return station.scaleSet.scales.filter(x => x.category == category.name)[0];
        },
        getCategorySettings: function (station, allergenCollectionSet, category) {
            let scale = this.getScale(station, category);
            let allergens = allergenCollectionSet.allergenCollections.filter(x => x.allergen.category == category.name);
            let rawValue = 0;
            for (let i = 0; i < allergens.length; ++i)
                rawValue += (isNaN(parseInt(allergens[i].value)) ? 0 : parseInt(allergens[i].value));
            if (allergens.length == 0)
                return {
                    rawValue: null,
                    gaugeValue: 0,
                    shortLabel: 'Not Counted',
                    label: 'Not Counted',
                    backgroundColor: 'success',
                    textColor: 'dark'
                };

            if (rawValue >= scale.range4Begin)
                return {
                    rawValue: rawValue,
                    gaugeValue: 95,
                    shortLabel: 'Very High',
                    label: 'Very High Concentration',
                    backgroundColor: 'danger',
                    textColor: 'white'
                };
            else if (rawValue >= scale.range3Begin)
                return {
                    rawValue: rawValue,
                    gaugeValue: 66,
                    shortLabel: 'High',
                    label: 'High Concentration',
                    backgroundColor: 'warning',
                    textColor: 'white'
                };
            else if (rawValue >= scale.range2Begin)
                return {
                    rawValue: rawValue,
                    gaugeValue: 33,
                    shortLabel: 'Moderate',
                    label: 'Moderate Concentration',
                    backgroundColor: 'info',
                    textColor: 'dark'
                };
            else if (rawValue > scale.range1Begin)
                return {                    
                    rawValue: rawValue,
                    gaugeValue: 5,
                    shortLabel: 'Low',
                    label: 'Low Concentration',
                    backgroundColor: 'success',
                    textColor: 'dark'
                };
                return {
                rawValue: 0,
                gaugeValue: 0,
                shortLabel: 'Not Present',
                label: 'Not Present',
                backgroundColor: 'success',
                textColor: 'dark'
            };            
        }
    }
}
